export const PASSWORD_REQUIREMENT_MESSAGE =
  'Password must be at least 8 characters and contain both letters and numbers.';

export const isPasswordValid = (password: string): boolean =>
  password.length >= 8 && /[A-Za-z]/.test(password) && /[0-9]/.test(password);
